import src from "IMAGE";
export default { src, width: 221, height: 218, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
